export const tailwindMergeConfig = {
  classGroups: {
    'font-size': [{ text: ['48', '40', '36', '32', '24', '20', '18', '16', '14', '12', '10', '8'] }],
  },
};
